import { BrowserRouter as Router } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./pages/HeaderSection/Header";

function App() {
  return (
    <Router>
      <Header />
      <Home />
    </Router>
  );
}

export default App;
